import api from '.';
import {
  CreateReferringPartnerRequest,
  ReferringPartner,
  ReferringPartnerOrganizationRef,
  ReferringPartnerWithOrganizations,
  UpdateReferringPartnerRequest,
} from '@karehero/models';

export const referringPartnerApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getAllReferringPartnersWithOrganizations: builder.query<
      ReferringPartnerWithOrganizations[],
      void
    >({
      query: () => '/referring-partner',
      providesTags: ['ReferringPartners'],
      transformResponse: (
        response: Array<{
          partner: ReferringPartner;
          organizations: ReferringPartnerOrganizationRef[];
        }>,
      ) =>
        response.map((item) => {
          const organizations = item.organizations ?? [];
          return {
            partner: item.partner,
            organizations,
            organizationIds: organizations.map((o) => o.id),
          };
        }),
    }),
    getReferringPartner: builder.query<ReferringPartner, string>({
      query: (id) => `/referring-partner/${id}`,
      providesTags: (_result, _err, id) => [{ type: 'ReferringPartners', id }],
    }),
    createReferringPartner: builder.mutation<
      ReferringPartner,
      CreateReferringPartnerRequest
    >({
      query: (body) => ({
        url: '/referring-partner',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['ReferringPartners'],
    }),
    updateReferringPartner: builder.mutation<
      ReferringPartner,
      { partnerID: string; body: UpdateReferringPartnerRequest }
    >({
      query: ({ partnerID, body }) => ({
        url: `/referring-partner/${partnerID}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['ReferringPartners'],
    }),
    deleteReferringPartner: builder.mutation<void, string>({
      query: (partnerID) => ({
        url: `/referring-partner/${partnerID}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['ReferringPartners'],
    }),
  }),
});

export const {
  useGetAllReferringPartnersWithOrganizationsQuery,
  useGetReferringPartnerQuery,
  useCreateReferringPartnerMutation,
  useUpdateReferringPartnerMutation,
  useDeleteReferringPartnerMutation,
} = referringPartnerApi;
